"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const config_1 = require("@completeanatomy/config");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const PanelItem_1 = __importDefault(require("../../atoms/PanelItem"));
const InfoboxSidePanelHeader_1 = require("../InfoboxSidePanelHeader");
const utils_1 = require("../../utils");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
function PanelMenu({ activeTab, onClose, isOpen, setIsOverlayOpened, items, }) {
    const isUpToTabletScreen = (0, ui_1.useScreenBreakpoint)(ui_1.sizeMainScreen.tablet);
    const { t } = (0, i18n_1.useTranslation)();
    const ref = (0, react_1.createRef)();
    const bridge = (0, bridge_1.useBridge)();
    const config = (0, config_1.useConfigService)();
    const imageBaseUrl = (config === null || config === void 0 ? void 0 : config.get('AWS_SERVER_S3_USERDATA')) || '';
    const getTitleText = (type) => {
        if (type === bridge_schema_1.InfoBoxTabType.None)
            return '';
        const key = (0, utils_1.getInfoboxTabName)(type);
        const tabName = i18n_1.Strings.infoBox.tabs[key];
        return t(tabName);
    };
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d, _e;
        (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.scrollTo) === null || _b === void 0 ? void 0 : _b.call(_a, 0, 0);
        const item = document.getElementById('selected-spot');
        if (item) {
            const topOffset = 10;
            const itemPosition = item.getBoundingClientRect().top;
            const parentPosition = ((_c = ref.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect().top) || 0;
            (_e = (_d = ref.current) === null || _d === void 0 ? void 0 : _d.scrollTo) === null || _e === void 0 ? void 0 : _e.call(_d, {
                top: itemPosition - parentPosition - topOffset,
                behavior: 'smooth',
            });
        }
    }, [items, ref]);
    const onItemClick = (spot) => {
        return () => {
            bridge === null || bridge === void 0 ? void 0 : bridge.selectInfoBoxListItem({
                type: activeTab,
                index: spot.index,
                identifier: spot === null || spot === void 0 ? void 0 : spot.identifier,
            });
            setIsOverlayOpened(true);
        };
    };
    return isOpen && activeTab ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!isUpToTabletScreen && ((0, jsx_runtime_1.jsx)(InfoboxSidePanelHeader_1.InfoboxSidePanelHeader, { titleText: getTitleText(activeTab), onClose: () => onClose(null), "data-e2e": 'PanelMenu_InfoboxSidePanelHeader' })), (0, jsx_runtime_1.jsx)(SpotsPanelList, { ref: ref, "data-e2e": 'PanelMenu_SpotsPanelList', children: items === null || items === void 0 ? void 0 : items.map((spot, index) => {
                    const isSelected = spot.isSelected;
                    const isFirstItem = index === 0;
                    const hasSelected = items.some(item => item.isSelected);
                    const selectedId = isSelected || (isFirstItem && !hasSelected)
                        ? 'selected-spot'
                        : undefined;
                    return ((0, jsx_runtime_1.jsx)(PanelItem_1.default, { id: selectedId, text: spot.title, image: imageBaseUrl + spot.img, isSelected: isSelected, onClick: onItemClick(spot), "data-e2e": 'PanelMenu_PanelItem' }, spot.identifier + `${isSelected ? 'selected' : ''}`));
                }) }, activeTab)] })) : null;
}
exports.default = PanelMenu;
const SpotsPanelList = styled_components_1.default.div `
  padding: 1px 4px 8px 1px;
  height: calc(100% - 54px);
  background-color: transparent;
  display: flex;
  align-content: flex-start;
  flex-wrap: wrap;
  gap: 16px;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.grasshopper.descriptionPanel.scroll.idle};
    border-radius: 6px;
  }

  &::-webkit-scrollbar-thumb:hover {
    opacity: 0.8;
  }

  ${ui_1.deviceMainScreen.tablet((0, styled_components_1.css) `
    height: 100vh;
    width: 100%;
    flex-wrap: nowrap;
    flex-direction: column;
  `)};
`;
